import React from 'react'
import List from './List'
import CommonLayout from "../../layouts/master/index";

const Campaigns = () => {
  return (
    <>
    <CommonLayout>
      <>
      <List/>
      </>
    </CommonLayout>
    </>
  )
}

export default Campaigns